/* PERF helpers (dev theme): deferred loading of things that are hidden until the visitor interacts.
   - Desktop mega-menu card images: data-jsmega-src -> src only on hover/focus/touch of that menu item (nothing is fetched until a visitor interacts; the card boxes already reserve 16:8 space).
   - Footer OnlyFins pop-up image: fetched on hover/touch of the footer trigger, or when the footer is about to scroll into view (not on slow connections).
   - Product card hover photo: its URL is held in data-hover-src (see snippets/product-grid-item.liquid). Mouse users get a right-sized copy shortly before the card is on screen or when it is hovered; touch devices never fetch it (it cannot be shown there). */
(function () {
  "use strict";
  var c = navigator.connection || {};
  var slow = !!(c.saveData || /(^|-)2g|3g/.test(c.effectiveType || ""));
  var desk = window.matchMedia && window.matchMedia("(min-width:992px)").matches;
  var warmed = false;
  function hydrate(scope) {
    [].forEach.call((scope || document).querySelectorAll(".jsmega img[data-jsmega-src]"), function (img) {
      img.decoding = "async";
      img.src = img.getAttribute("data-jsmega-src");
      img.removeAttribute("data-jsmega-src");
    });
  }
  function warm() {
    if (warmed) return;
    warmed = true;
    var m = document.querySelector("#jsOnlyFinsModal img");
    var u = m && m.getAttribute("src");
    if (u) { var i = new Image(); i.src = u; }
  }
  function hit(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var li = t.closest(".jsmega__topitem");
    if (li) hydrate(li);
    if (t.closest(".js-onlyfins-trigger")) warm();
  }
  ["pointerover", "focusin", "touchstart"].forEach(function (ev) {
    document.addEventListener(ev, hit, { passive: true, capture: true });
  });
  window.addEventListener("load", function () {
    if (slow || !desk || !("IntersectionObserver" in window)) return;
    var trig = document.querySelector(".js-onlyfins-trigger");
    if (!trig) return;
    var fio = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { fio.disconnect(); warm(); }
    }, { rootMargin: "800px 0px" });
    fio.observe(trig);
  });

  var fine = !!(window.matchMedia && window.matchMedia("(hover:hover) and (pointer:fine)").matches);
  function loadHover(img) {
    var u = img.getAttribute("data-hover-src");
    if (!u) return true;
    var box = img.closest(".tt-image-box") || img.parentElement;
    var w = box ? box.getBoundingClientRect().width : 0;
    if (!w) return false;
    var px = Math.min(600, Math.max(100, Math.ceil(w * Math.min(window.devicePixelRatio || 1, 2))));
    img.removeAttribute("data-hover-src");
    img.decoding = "async";
    img.loading = "eager"; /* decided to load now; a clipped loading=lazy image would otherwise never count as visible */
    img.src = u.replace(/_\d+x(\.(?:jpe?g|png|webp|gif))/i, "_" + px + "x$1");
    return true;
  }
  var cio = fine && "IntersectionObserver" in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var img = e.target.querySelector("img.js-hover-img[data-hover-src]");
      if (!img || loadHover(img)) cio.unobserve(e.target);
    });
  }, { rootMargin: "300px 0px" }) : null;
  function watchCards() {
    if (!cio) return;
    [].forEach.call(document.querySelectorAll("img.js-hover-img[data-hover-src]"), function (img) {
      var card = img.closest(".tt-product");
      if (card && !card.__jsHov) { card.__jsHov = 1; cio.observe(card); }
    });
  }
  if (fine) {
    document.addEventListener("pointerover", function (e) {
      var card = e.target && e.target.closest && e.target.closest(".tt-product");
      var img = card && card.querySelector("img.js-hover-img[data-hover-src]");
      if (img) loadHover(img);
    }, { passive: true, capture: true });
    var ht;
    var again = function () { clearTimeout(ht); ht = setTimeout(watchCards, 250); };
    document.addEventListener("DOMContentLoaded", function () { watchCards(); setTimeout(watchCards, 1500); setTimeout(watchCards, 4000); });
    window.addEventListener("load", watchCards);
    window.addEventListener("scroll", again, { passive: true });
    document.addEventListener("shopify:section:load", again);
  }

  /* Lazy carousel start: the three home-page product carousels (.tt-carousel-products-js) are each initialised by theme.min.js at
     DOM ready (Slick builds ~13 cloned cards, measures widths through jQuery and forces layout - about 1.7 s per carousel on a phone).
     Carousels that start well below the first screen are now initialised just before they scroll into view, with the same arguments;
     everything on or near the first screen starts exactly as before. Nothing is hidden or removed: the markup is present from the start. */
  (function () {
    var $ = window.jQuery;
    if (!$ || !$.fn || !("IntersectionObserver" in window)) return;
    var SEL = ".tt-carousel-products-js";
    var done = false;
    function belowFold(el) {
      var r = el.getBoundingClientRect();
      return r.top > (window.innerHeight || 800) * 1.6;
    }
    function nudgeArrows(el) {
      /* what theme.min.js alignmentArrowValue() does for a freshly built slider */
      var box = $(el).closest(".tt-alignment-img");
      if (!box.length) return;
      var arrows = box.find(".slick-arrow");
      if (!arrows.length) return;
      if ((window.innerWidth || $(window).width()) > 1024) { arrows.removeAttr("style"); return; }
      var img = box.find(".tt-image-box").first();
      if (!img.length) return;
      arrows.css("top", (img.innerHeight() / 2) - (arrows.innerHeight() / 2) - parseInt(box.css("marginTop"), 10) + "px");
    }
    function startNow(el) {
      var job = el.__jsLazySlick;
      if (!job || el.slick) return;
      el.__jsLazySlick = null;
      io.unobserve(el);
      el.style.height = job.styleH; el.style.overflow = job.styleO;
      job.orig.apply($(el), job.args);
      setTimeout(function () { nudgeArrows(el); }, 260);
    }
    var pending = [];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        startNow(e.target);
      });
    }, { rootMargin: "0px 0px 900px 0px" });
    function wrap(orig) {
      var wrapped = function () {
        var args = arguments, first = args[0];
        if (typeof first === "string") {
          /* method calls (e.g. 'setPosition' on window resize) must skip carousels that have not been started yet */
          var started = this.filter(function () { return !!this.slick; });
          if (!started.length) return this;
          return orig.apply(started, args);
        }
        var now = [];
        this.each(function () {
          if (this.matches && this.matches(SEL) && !this.slick && belowFold(this)) {
            /* keep the page the same height until the carousel starts: reuse the height of the first (already started) carousel */
            var ref = document.querySelector(SEL + ".slick-initialized"), h = ref ? Math.round(ref.getBoundingClientRect().height) : 0;
            this.__jsLazySlick = { orig: orig, args: args, styleH: this.style.height, styleO: this.style.overflow };
            if (h > 100) { this.style.height = h + "px"; this.style.overflow = "hidden"; }
            pending.push(this);
            io.observe(this);
          } else now.push(this);
        });
        return now.length ? orig.apply($(now), args) : this;
      };
      wrapped.__jsLazy = true;
      return wrapped;
    }
    /* safety net: anything still waiting 12 s after load starts when the browser is idle */
    window.addEventListener("load", function () {
      setTimeout(function () {
        var run = function () { pending.forEach(startNow); };
        if ("requestIdleCallback" in window) requestIdleCallback(run, { timeout: 4000 }); else run();
      }, 12000);
    });
    var cur = $.fn.slick;
    if (typeof cur === "function") { if (!cur.__jsLazy) $.fn.slick = wrap(cur); return; }
    /* Slick (vendor.min.js) is not defined yet: wrap it the moment it is assigned */
    try {
      Object.defineProperty($.fn, "slick", {
        configurable: true, enumerable: true,
        get: function () { return cur; },
        set: function (v) { cur = (typeof v === "function" && !v.__jsLazy) ? wrap(v) : v; }
      });
    } catch (_) { /* leave Slick untouched */ }
  })();

  /* Cart page: the layout-shift reserve (see layout/theme.liquid #js-cart-reserve) is dropped if the free-gift panel never arrives. */
  window.addEventListener("load", function () {
    if (!document.body || !document.body.classList.contains("pagecart")) return;
    setTimeout(function () { if (!document.querySelector(".jsfb-wrap")) document.body.classList.add("jsfb-noreserve"); }, 9000);
  });

  /* Animation gate: the storefront has ~100-150 endlessly running CSS animations (rainbow card borders, glows, shimmer).
     Painting them all at 60fps starves slower phones. Same animations, same look - but only the ones that are on screen
     (plus a 200px margin) actually run; off-screen ones are paused and resume when scrolled into view. */
  (function () {
    if (!("IntersectionObserver" in window) || !document.getAnimations || typeof CSSAnimation === "undefined") return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var list = e.target.__jsAnims || [];
        list.forEach(function (a) {
          try { if (e.isIntersecting) { if (a.playState === "paused") a.play(); } else if (a.playState === "running") a.pause(); } catch (_) { /* ignore */ }
        });
      });
    }, { rootMargin: "200px 0px" });
    function scan() {
      var all; try { all = document.getAnimations(); } catch (_) { return; }
      all.forEach(function (a) {
        var ef = a.effect, t = ef && ef.target;
        if (!t || !(a instanceof CSSAnimation)) return;
        var it = ef.getComputedTiming ? ef.getComputedTiming().iterations : 1;
        if (it !== Infinity) return;
        if (!t.__jsAnims) { t.__jsAnims = []; io.observe(t); }
        if (t.__jsAnims.indexOf(a) < 0) t.__jsAnims.push(a);
      });
    }
    var timer;
    function later(ms) { clearTimeout(timer); timer = setTimeout(scan, ms); }
    document.addEventListener("DOMContentLoaded", function () { scan(); setTimeout(scan, 800); setTimeout(scan, 2500); setTimeout(scan, 6000); });
    window.addEventListener("load", function () { scan(); setTimeout(scan, 1500); setTimeout(scan, 5000); });
    window.addEventListener("scroll", function () { later(250); }, { passive: true });
    window.addEventListener("resize", function () { later(400); });
    document.addEventListener("shopify:section:load", function () { later(300); });
  })();
})();
